import { AxiosError } from 'axios';

export const getArrayApiErrors = (error: unknown): string[] => {
  const errors: string[] = [];
  if (error instanceof AxiosError) {
    const e = error.response?.data?.message || error.response?.data?.error;

    if (Array.isArray(e)) {
      errors.push(...e);
    } else if (typeof e === 'string') {
      errors.push(e);
    }
  }

  if (errors.length === 0) {
    errors.push('Internal server error');
  }

  return errors;
};
